import React from 'react';
import { Save, RotateCcw, X } from 'lucide-react';

const JobFormAction = ({ onCancel, onReset, isEdit, isSubmitting }) => (
  <div className="card-footer border-top p-3 p-md-4 bg-light">
    {/* Desktop Layout - Hidden on mobile */}
    <div className="d-none d-md-flex justify-content-between align-items-center">
      <div className="d-flex gap-2">
        {onCancel && (
          <button 
            type="button" 
            className="btn btn-outline-secondary px-3 d-flex align-items-center"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            <X size={18} className="me-2" />
            Cancel
          </button>
        )}
        {!isEdit && onReset && (
          <button 
            type="button" 
            className="btn btn-outline-primary px-3 d-flex align-items-center"
            onClick={onReset}
            disabled={isSubmitting}
          >
            <RotateCcw size={18} className="me-2" />
            Reset
          </button>
        )}
      </div>
      <button 
        type="submit" 
        className="btn btn-primary btn-md px-5 d-flex align-items-center"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {isEdit ? 'Updating...' : 'Saving...'}
          </>
        ) : (
          <>
            <Save size={18} className="me-2" />
            {isEdit ? 'Update Job' : 'Create Job'}
          </>
        )}
      </button>
    </div>

    {/* Mobile Layout - Hidden on desktop */}
    <div className="d-md-none">
      <button 
        type="submit" 
        className="btn btn-primary w-100 mb-3 py-3 d-flex align-items-center justify-content-center"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span>{isEdit ? 'Updating...' : 'Saving...'}</span>
          </>
        ) : (
          <>
            <Save size={18} className="me-2" />
            <span>{isEdit ? 'Update Job' : 'Create Job'}</span>
          </>
        )}
      </button>

      <div className="d-flex gap-2">
        {onCancel && (
          <button 
            type="button" 
            className="btn btn-outline-secondary flex-fill py-2 d-flex align-items-center justify-content-center"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            <X size={16} className="me-1" />
            <span className="d-none d-sm-inline">Cancel</span>
          </button>
        )}
        {!isEdit && onReset && (
          <button 
            type="button" 
            className="btn btn-outline-primary flex-fill py-2 d-flex align-items-center justify-content-center"
            onClick={onReset}
            disabled={isSubmitting}
          >
            <RotateCcw size={16} className="me-1" />
            <span className="d-none d-sm-inline">Reset</span>
          </button>
        )}
      </div>
    </div>
  </div>
);

export default JobFormAction;
